import { EXTRAS, FIXED_EXTRAS, MIN_INTERVENTION, PRICE_LEVELS } from "@/data/services";

export function computeEstimate({ item, quantity, priceLevelId, selectedExtras, selectedFixed }) {
  if (!item) return { base: 0, withLevel: 0, extrasAmount: 0, fixedAmount: 0, subtotal: 0, total: 0, levelFactor: 1, extrasPct: 0, minApplied: false };
  const level = PRICE_LEVELS.find(p => p.id === priceLevelId) || PRICE_LEVELS[1];
  const qty = Math.max(0, Number(quantity) || 0);
  const base = item.price * qty;
  const withLevel = base * level.factor;

  const extrasPct = EXTRAS
    .filter(e => selectedExtras.includes(e.id))
    .reduce((s, e) => s + e.pct, 0);
  const extrasAmount = withLevel * extrasPct;

  const fixedAmount = FIXED_EXTRAS
    .filter(f => selectedFixed.includes(f.id))
    .reduce((s, f) => s + f.amount, 0);

  const subtotal = withLevel + extrasAmount + fixedAmount;
  const minApplied = subtotal > 0 && subtotal < MIN_INTERVENTION;
  const total = minApplied ? MIN_INTERVENTION : subtotal;

  return { base, withLevel, extrasAmount, fixedAmount, subtotal, total, levelFactor: level.factor, extrasPct, minApplied };
}

export function formatEUR(n) {
  return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(Math.round(n || 0));
}
